import { createSlice } from "@reduxjs/toolkit";

const popupSlice = createSlice({
  name: "popup",
  initialState: {
    isModalOpen: false,
  },
  reducers: {
    show_popup(state) {
      state.isModalOpen = true;
    },
    hide_popup(state) {
      state.isModalOpen = false;
    },
  },
});

export const popupActions = popupSlice.actions;
export default popupSlice;
